/* eslint-disable semi */
import Router from 'vue-router'
import MyAccount from '@/components/account/MyAccount.vue'
import ListCover from '@/components/ListCover.vue'
import ListICE from '@/components/ListICE.vue'
import ListBuyerClaim from '@/components/ListBuyerClaim.vue'
import Login from '@/components/Login'
import NewPassword from '@/components/login/NewPassword'
import ListCoverLate from '@/components/cover/ListCoverLate'
import ListCoverClaimed from '@/components/cover/ListCoverClaimed'
import ListCoverActivated from '@/components/cover/ListCoverActivated'
import ListCoverArchived from '@/components/cover/ListCoverArchived'
import ListCoverQuoted from '@/components/cover/ListCoverQuoted'
import ListCoverSettled from '@/components/cover/ListCoverSettled'
import ListCoverTimebarred from '@/components/cover/ListCoverTimebarred'
import UnderConstruction from '@/components/UnderConstruction'
import ForgotPassword from '@/components/login/ForgotPassword'
import ForgotPasswordConfirmation from '@/components/login/ForgotPasswordConfirmation'
import ListApiKeys from '@/components/developer/apikeys/ListApiKeys'
import Signup from '@/components/login/Signup'
import SignupConfirmation from '@/components/login/SignupConfirmation'
import MailVerification from '@/components/login/MailVerification'
import auth from '@/services/Auth'

const baseRoutes = [
  {
    path: '/',
    component: ListCover,
    beforeEnter: hasCoverageAccess,
    props: true,
    alias: '/home',
    children: [
      {
        path: '',
        name: 'home',
        component: ListCoverLate
      },
      {
        path: 'activated',
        component: ListCoverActivated
      },
      {
        path: 'claimed',
        component: ListCoverClaimed
      },
      {
        path: 'archived',
        component: ListCoverArchived
      },
      {
        path: 'quoted',
        component: ListCoverQuoted
      },
      {
        path: 'settled',
        component: ListCoverSettled
      },
      {
        path: 'timebarred',
        component: ListCoverTimebarred
      }
    ]
  },
  {
    path: '/myaccount',
    name: 'myaccount',
    component: MyAccount
  },
  {
    path: '/buyerclaims',
    name: 'buyerclaims',
    component: ListBuyerClaim,
    beforeEnter: hasBuyerClaimAccess
  },
  {
    path: '/ice',
    name: 'ice',
    component: ListICE,
    beforeEnter: hasIceAccess
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: logoutAndRedirect
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: logout
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: ForgotPassword,
    beforeEnter: logoutAndRedirect
  },
  {
    path: '/resetconfirmation',
    props: true,
    name: 'resetconfirmation',
    component: ForgotPasswordConfirmation,
    beforeEnter: logoutAndRedirect
  },
  {
    path: '/newpassword',
    name: 'newpassword',
    component: NewPassword,
    beforeEnter: logoutAndRedirect
  },
  {
    path: '/underconstruction',
    name: 'underconstruction',
    component: UnderConstruction,
    beforeEnter: requireAuth
  },
  {
    path: '/apikeys',
    name: 'apikeys',
    component: ListApiKeys,
    beforeEnter: requireAuth
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup,
    beforeEnter: isDemoEnv
  },
  {
    path: '/signupconfirmation',
    props: true,
    name: 'signupconfirmation',
    component: SignupConfirmation,
    beforeEnter: logoutAndRedirect
  },
  {
    path: '/mailverification',
    props: true,
    name: 'mailverification',
    component: MailVerification,
    beforeEnter: logoutAndRedirect
  },
  {
    path: '*',
    name: 'pagenotfound',
    beforeEnter: redirectHomePage
  }
];

// const routes = baseRoutes.concat(messagesRoutes, peopleRoutes);
const routes = baseRoutes;
export default new Router({
  routes
});

function requireAuth (to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

function isDemoEnv (to, from, next) {
  auth.logout()
  if (`${process.env.VUE_APP_NODE_ENV_API}`.toUpperCase() !== 'prod'.toUpperCase()) {
    next()
  } else {
    next({
      path: '/login'
    })
  }
}
function logoutAndRedirect (to, from, next) {
  auth.logout()
  next()
}

function hasCoverageAccess (to, from, next) {
  if (!auth.hasCoverageAccess() && !auth.hasClaimAccess()) {
    if (!auth.loggedIn()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next({
        path: '/underconstruction'
      })
    }
  } else {
    next()
  }
}

function hasIceAccess (to, from, next) {
  if (!auth.hasIceAccess()) {
    if (!auth.loggedIn()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next({
        path: '/underconstruction'
      })
    }
  } else {
    next()
  }
}

function hasBuyerClaimAccess (to, from, next) {
  if (!auth.hasBuyerClaimAccess()) {
    if (!auth.loggedIn()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next({
        path: '/underconstruction'
      })
    }
  } else {
    next()
  }
}

function redirectHomePage (to, from, next) {
  if (auth.loggedIn()) {
    next({
      path: '/'
    })
  } else {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
}

function logout (to, from, next) {
  auth.logout()
  next('/login')
}
